import React from "react";
import { Box } from '@mui/joy';
import { Pie, Table, Bar } from 'src/mtska-frontend-app-component';
import { useTranslation } from 'react-i18next';
import { Filters, Overview } from ".";
import KPISet from "./KPISet";
import useFiltersFromLocation from "src/mtska-frontend-app-scaffolding/hooks/useFiltersFromLocation";
import { useDataProvider } from "src/mtska-frontend-data-provider";
import { useNavigate } from 'react-router-dom';
import PieFleet from "./RunningDashboard.PieFleet";
import PiePotential from "./RunningDashboard.PiePotential";
import PieAccounting from "./RunningDashboard.PieAccounting";
import PieExpiration from "./RunningDashboard.PieExpiration";
import PieTraceKM from "./RunningDashboard.PieTraceKM";
import PiePurchase from "./RunningDashboard.PiePurchase";
import PivotTable from "src/mtska-frontend-app-component/components/Chart/PivotTable";

const AdministrationDashboard = React.forwardRef((props, ref) => {

    const showPivotProduzionePerPartner = true;

    const { item: user } = useDataProvider('auth/token');

    const { t } = useTranslation();
    const navigate = useNavigate()

    const [filters, setFilters] = useFiltersFromLocation();

    function handleFilterChange(field, newValue) {
        setFilters(prevFilters => {

            const items = Array.isArray(prevFilters?.items) ? [...prevFilters.items] : [];
            const index = items.findIndex(item => item.field === field);

            if (index !== -1) {
                items[index] = { ...items[index], value: newValue };
            } else {
                items.push({
                    field,
                    operator: "equals",
                    value: newValue
                });
            }

            return {
                ...prevFilters,
                items
            };
        });
    }



    const getTransposedDateFirstOfMonth = (months) => {
        const today = new Date();
        const firstOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

        firstOfMonth.setMonth(firstOfMonth.getMonth() + months);

        const yyyy = firstOfMonth.getFullYear();
        const mm = String(firstOfMonth.getMonth() + 1).padStart(2, '0');
        const dd = String(firstOfMonth.getDate()).padStart(2, '0');

        return `${yyyy}-${mm}-${dd}`;
    }

    return (
        <Box ref={ref}>
            {
                showPivotProduzionePerPartner &&
                <PivotTable
                    dataProviderName="statisticsviews/fleet/pivot/views_cars_car"
                    //filters={filters}
                    filters={{
                        items: [
                            {
                                field: "_related_contract_orderTarget_at",
                                operator: "between",
                                value: { from: "2024-01-01", to: "2024-12-31" }
                            }
                        ]
                    }}
                    rows={[
                        { field: '_related_renter_name', sort: 'asc' },
                        { field: '_related_account_area_name', sort: 'asc' },
                        { field: '_related_account_shop_name', sort: 'asc' },
                        { field: '_related_account_name', sort: 'asc' }
                    ]}
                    values={[
                        { field: '_related_contract_production_renter', aggregate: 'sum' }
                    ]}
                    columns={[
                        { field: '_related_contract_orderTarget_at', bucket: 'month' }
                    ]}
                />
            }
        </Box>
    )
})

export default AdministrationDashboard;
